module.exports = __webpack_public_path__ + "s16.no1.b968dac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s16.no1.jpg
// module id = Dk8M
// module chunks = 0